import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Inject, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModalService } from 'src/app/modules/events/services/common-modal.service';
import { TranslationService } from '../service/translation.service';
import { GenericTooltipComponent } from "../components/generic-tooltip/generic-tooltip.component";
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GenericTooltipComponent, CommonModule, TranslateModule],
})
export class CommonModalComponent implements OnInit {

  @Inject(CommonModalService) private readonly commonModalService = inject(CommonModalService)
  private readonly _translationService = inject(TranslationService)
  private readonly _cdr = inject(ChangeDetectorRef)
  private readonly _destroyRef = inject(DestroyRef)

  headerTitle: string = '';
  isCloseButtonClicked: boolean = false;
  isSaveButtonClicked: boolean = false;
  isCloseButtonVisible: boolean = false;
  isSaveButtonVisible: boolean = false;
  showButtonTooltip: boolean = false;

  @Input()
  isCloseModal: boolean | undefined;

  @Input()
  closeButtonTitle: string = '';

  @Input()
  saveButtonTitle: string = '';

  @Input()
  showModalContent: any = '';

  @Input()
  doneButtonDisabled: any;

  @Input()
  templateBtn: boolean | undefined = true;

  @Input()
  component: string | undefined

  @Input()
  isHeaderVisible: boolean | undefined

  @Output()
  closeModalEmitter = new EventEmitter<boolean>();

  @Output()
  saveModalEmitter = new EventEmitter<boolean>();

  @Input()
  type: any

  @Input()
  isFooterVisible: any

  @Input()
  isCloseBtnVisible: boolean = false

  @Input() showToolTip: boolean = false;
  @Input() isInfoSectionAvailable: boolean = false

  translationData: any;


  ngOnInit(): void {
    this.commonModalService._modalHeaderTitle
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        this.headerTitle = data;
        this._cdr.markForCheck();
      });

    this.commonModalService._modalHeaderIsCloseBtnVisible
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        this.isCloseButtonVisible = data;
        this._cdr.markForCheck();
      });

    this.commonModalService._modalHeaderIsSaveBtnVisible
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        this.isSaveButtonVisible = data;
        this._cdr.markForCheck();
      });
  }

  close() {
    this.closeModalEmitter.emit(true);
  }

  save() {
    this.saveModalEmitter.emit(true);
  }



}
